export const blockIconsBrandNestGaleWifiNew = (
	<span className='material-symbols-outlined'>nest_gale_wifi</span>
);
